import React, { useState } from "react";
import { useQuery } from "@apollo/client";
import { GET_WALLETS } from "../graphql/wallets";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  CircularProgress,
  Button,
  Box,
  Alert,
  Dialog,
  IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import WalletDetails from "./WalletDetails";
import WalletFormDialog from "./WalletFormDialog";

export function WalletsPage() {
  const { data, loading, error, refetch } = useQuery(GET_WALLETS);
  const wallets = data?.wallets || [];
  const [selectedWalletId, setSelectedWalletId] = useState<string | null>(null);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [formOpen, setFormOpen] = useState(false);
  const [editWallet, setEditWallet] = useState<any | null>(null);

  const handleRowClick = (walletId: string) => {
    setSelectedWalletId(walletId);
    setDetailsOpen(true);
  };

  const handleEdit = (wallet: any) => {
    setEditWallet(wallet);
    setFormOpen(true);
  };

  const handleNewWallet = () => {
    setEditWallet(null);
    setFormOpen(true);
  };

  return (
    <Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={2}
      >
        <Typography variant="h4">Wallets</Typography>
        <Button variant="contained" color="primary" onClick={handleNewWallet}>
          + New Wallet
        </Button>
      </Box>
      {loading ? (
        <CircularProgress />
      ) : error ? (
        <Alert severity="error">Error loading wallets: {error.message}</Alert>
      ) : wallets.length === 0 ? (
        <Typography>No wallets found.</Typography>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Balance</TableCell>
                <TableCell>Currency</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Created</TableCell>
                <TableCell>Updated</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {wallets.map((wallet: any) => (
                <TableRow
                  key={wallet.id}
                  hover
                  sx={{ cursor: "pointer" }}
                  onClick={() => handleRowClick(wallet.id)}
                >
                  <TableCell>{wallet.name}</TableCell>
                  <TableCell>{wallet.balance?.toLocaleString()}</TableCell>
                  <TableCell>{wallet.currency}</TableCell>
                  <TableCell>{wallet.status}</TableCell>
                  <TableCell>
                    {new Date(wallet.createdAt).toLocaleString()}
                  </TableCell>
                  <TableCell>
                    {new Date(wallet.updatedAt).toLocaleString()}
                  </TableCell>
                  <TableCell onClick={(e) => e.stopPropagation()}>
                    <IconButton size="small" onClick={() => handleEdit(wallet)}>
                      <EditIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      {/* Wallet Details Dialog */}
      <Dialog
        open={detailsOpen}
        onClose={() => setDetailsOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        {selectedWalletId && <WalletDetails walletId={selectedWalletId} />}
      </Dialog>
      {/* Wallet Form Dialog */}
      <WalletFormDialog
        open={formOpen}
        initialValues={editWallet}
        onClose={() => setFormOpen(false)}
        onSave={async () => {
          setFormOpen(false);
          refetch();
        }}
      />
    </Box>
  );
}

export default WalletsPage;
